// extracted by mini-css-extract-plugin
export const baristaHeroLeftMobile = "baristaHero-module--barista-hero-left-mobile--HGFL0";
export const baristaHeroRightMobile = "baristaHero-module--barista-hero-right-mobile--1h06z";
export const baristaHeroLeftTablet = "baristaHero-module--barista-hero-left-tablet--3XSIa";
export const baristaHeroRightTablet = "baristaHero-module--barista-hero-right-tablet--HnDLR";
export const baristaHeroLeftDesktop = "baristaHero-module--barista-hero-left-desktop--17hQK";
export const baristaHeroRightDesktop = "baristaHero-module--barista-hero-right-desktop--B8NpW";